var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95417 2.90417H1.91667C1.40834 2.90417 0.920823 3.09732 0.561379 3.44114C0.201934 3.78495 0 4.25127 0 4.7375V14.6375C0 15.1237 0.201934 15.59 0.561379 15.9339C0.920823 16.2777 1.40834 16.4708 1.91667 16.4708H12.4583C13.5125 16.4708 14.375 15.5542 14.375 14.5458V7.30417L10.5417 11.1542C10.2542 11.4292 9.87083 11.7042 9.39167 11.7958L6.80417 12.3458C5.175 12.6208 3.64167 11.1542 3.92917 9.50417L4.50417 6.84583C4.6 6.3875 4.8875 5.92917 5.175 5.65417L8.05 2.8125L7.95417 2.90417Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1 1.16273C15.9198 0.726096 15.579 0.367498 15.1417 0.154401C14.792 0.00771211 14.4046 -0.0357546 14.0289 0.0295729C13.6533 0.0949005 13.3066 0.266045 13.0333 0.521068L12.4583 1.07107L15.2375 3.82107L15.7167 3.27107C15.9027 3.08954 16.0492 2.87457 16.1479 2.63857C16.2466 2.40258 16.2955 2.15022 16.2917 1.89607C16.2917 1.71273 16.2917 1.43773 16.1 1.16273ZM13.8 5.19607L11.1167 2.44607L6.51667 7.0294L6.42083 7.3044L5.75 10.0544C5.75 10.3294 6.0375 10.6961 6.325 10.6044L8.9125 10.0544L9.2 9.96273L13.7042 5.3794L13.8 5.19607Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.dc444e0a13e6d4849c1a9f799fc94496.svg";
export { ForwardRef as ReactComponent };